// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1lNzI","buttons":"Footer_buttons__2XXzz"};